export * from './lib/content-fade-directive.module';

export { AccredibleContentFadeDirective } from './lib/content-fade.directive';
